// static/src/composables/useReportChatContext.js
//
// D-1c: lets AIChatWidget.vue answer with real report data instead of
// generic SEO textbook answers. AIChatWidget is mounted globally in
// App.vue as a SIBLING of <router-view> (see CLAUDE.md D-1c), not a
// descendant of ReportPage.vue — so inject('reportData') isn't reachable
// there, and this is a plain shared module-level ref instead, following
// the same lightweight-composable pattern as useReportDensity.js.
//
// ReportPage.vue calls setReportChatContext() with a lightweight summary
// when report data loads, and clearReportChatContext() on unmount so the
// context doesn't leak into the chat on unrelated pages. AIChatWidget.vue
// reads it via useReportChatContext() and sends it as report_context.

import { ref } from 'vue';

const reportChatContext = ref(null);

/** @returns {import('vue').Ref<object|null>} */
export function useReportChatContext() {
  return reportChatContext;
}

export function setReportChatContext(summary) {
  reportChatContext.value = summary;
}

export function clearReportChatContext() {
  reportChatContext.value = null;
}
